import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withRouter, Link } from 'react-router-dom';
import styles from './Card.module.scss';
import RetailerImage from '../RetailerImage';
import history from '../../../utils/history';
import { datediff } from '../../../utils/dateHelper';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { useMixpanel } from 'react-mixpanel-browser';
import { RetailerApprovalStatus } from '../../../constants/retailerStatus';

function Card({ invitedAt, retailer, supplierId, action }) {
  const mixpanel = useMixpanel();
  const reportBi = (event, meta) => {
    reportBusinessActionToMixpanel(mixpanel, event, meta);
  };

  const goToApprovalRetailer = (e) => {
    if (e.target.tagName === 'A') {
      return false;
    } else {
      const name = e.target.alt ? e.target.alt : e.target.innerText;
      reportBi(`retailer-card-click`, { retailer: name });
      history.push(`/suppliers/${supplierId}/retailers/${retailer.id}`);
    }
  };

  return (
    <div onClick={goToApprovalRetailer} className="column">
      <div className={cn(styles.shadow, styles.card)}>
        <div className={styles.logo}>
          <RetailerImage image={retailer.square_logo_path} name={retailer.name} size="131" />
          <p>{retailer.name}</p>
        </div>
        <div className={styles.desc}>
          <p>
            {action === RetailerApprovalStatus.PENDING
              ? `Pending your action (${datediff(invitedAt)} days)`
              : `Approved ${datediff(invitedAt)} days ago`}
          </p>
          {retailer.website ? (
            <p>
              <Link target="_blank" to={`//${retailer.website}`}>
                {retailer.website}
              </Link>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Card);

Card.propTypes = {
  retailer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    square_logo_path: PropTypes.string,
    website: PropTypes.string,
  }).isRequired,
  invitedAt: PropTypes.string.isRequired,
  supplierId: PropTypes.number.isRequired,
  action: PropTypes.string.isRequired,
};
